export const OW_PATHS = {
  'staging.yunion.io': 'http://www-staging.yunion.io',
  'yunion.io': 'http://www-staging.yunion.io',
  'cloud.yunion.cn': 'https://www.yunion.cn',
  'yunion.cn': 'https://www.yunion.cn',
  default: 'http://www-staging.yunion.io',
}
